import { IPdfTemplates } from "../interfaces/IPdfTemplate"
import { IRcaPatientListData, IRcaPatientListFilters } from "../interfaces/rca/IRcaPatientListData"
import { UPDATE_RCA_PATIENT_LIST_FILTERS } from "../constants/actionTypes"
import RCAPatientList from "../containers/noProgressRCA/RCAPatientList"
import { RCA_PATIENT_LIST_LIMIT, RCAPatientListTabKeys } from "../containers/noProgressRCA/helper"
import { RCAClinicalProgressFilter, RCAPatientListSortBy, RCAProgressTags, RCAReportSearchStatus } from "../constants"

function init() {
	return {
		patientListFilters: {
			rcaCurrSelectedTab: RCAPatientListTabKeys.MY_PATIENTS_RCA,
			rcaPatientListPageNo: 1,
			rcaCoachFilter: null,
			rcaPatientListPageSize: RCA_PATIENT_LIST_LIMIT,
			rcaStatusFilter: RCAReportSearchStatus.OPEN,
			rcaPatientListSortBy: RCAPatientListSortBy.DEFAULT_PROGRESS_REPORT_SORT,
			sortDirection: "ASC",
			latestDiagnosticReportStartDate: null,
			latestDiagnosticReportEndDate: null,
			clinicalProgressFilter: RCAClinicalProgressFilter.NO_PROGRESS,
			tag: RCAProgressTags.NA,
		} as IRcaPatientListFilters,
	} as IRcaPatientListData
}
export const rcaPatientListDataReducer = (state = init(), action: any): IRcaPatientListData => {
	switch (action.type) {
		case UPDATE_RCA_PATIENT_LIST_FILTERS:
			return {
				...state,
				patientListFilters: { ...state.patientListFilters, ...action.patientListFilters },
			}
		default:
			return state
	}
}
